import { render, staticRenderFns } from "./OrticDatepicker.vue?vue&type=template&id=63dae873&"
import script from "./OrticDatepicker.vue?vue&type=script&lang=js&"
export * from "./OrticDatepicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports